import { CompanyConfig } from "#root/config/interfaces/company-config.interface";

export const COMPANY_CONFIG_RM: CompanyConfig = {
  name: "Inmobiliaria Platino Maya S.A. de C.V.",
  socialMediaName: "residencialmaya",
  email: "",
  rtn: "05019026371423",
  watermark: "assets/images/companies/residencial-maya/app_isotype.png",
  blackLettersLogo:
    "assets/images/companies/residencial-maya/green_letters_logo.png",
  oneLineBlackLettersLogo:
    "assets/images/companies/residencial-maya/one_line_green_letters_logo.png",
  quoteGroupLogo:
    "assets/images/companies/inmobiliaria-platino/black_letters_logo.png",
  quoteLogo: "assets/images/companies/residencial-maya/green_letters_logo.png",
  virtualSign: "assets/images/companies/inmobiliaria-platino/virtual_sign.png",
  quoteParkingClause: "estacionamiento para {{VEHICULOS}}",
  quoteParkingInRooms: true,
  quoteRooms: ["sala", "comedor"],
};
